import { postRequest, getUserInfo } from '../../../utils/utils';
import {Toast} from 'antd-mobile';
// ------------------------------------
// Constants
// ------------------------------------
export const JIABANBUKA_LIST = 'JIABANBUKA_LIST'

// ------------------------------------
// Actions
// ------------------------------------
export const getJiaBanBuka = (pagesize,oldData,type, keyword) => {
    return async (dispatch, getState) => {
        postRequest(`/jiabanbk/getlist`, `keyword=${keyword || ''}&&page_size=${pagesize}`).then((value) => {
            console.log(value);
            if(value.status === 0) {
                dispatch({ type: JIABANBUKA_LIST, payload:{hasdata: false , listdata:[],count:0} })
                if(value.msg === '请登陆！') {
                    localStorage.removeItem('daka_token')
                    alert('账号已在别处登录,请重新登录')
                    this.props.history.push('/')
                }
            } else {
                if(value.data!='') {
                    let newlist=[];
                    newlist = value.data.list
                    if(oldData && oldData.length > 0) {
                        newlist = oldData.concat(value.data.list)
                    }
                    dispatch({type: JIABANBUKA_LIST, payload: {listdata: newlist,hasdata: true,count:value.data.count }})
                }
                else {
                    dispatch({ type: JIABANBUKA_LIST, payload:{hasdata: false , listdata:[],count:0} })
                }
            }
        })
    }
}

export const getJiaBanBukaChecklist = (pagesize,oldData,type, keyword) => {
    return async (dispatch, getState) => {
        postRequest(`/jiabanbk/checklist`, `keyword=${keyword || ''}&&page_size=${pagesize}`).then((value) => {
            if(value.status === 0) {
                dispatch({ type: JIABANBUKA_LIST, payload:{checklistdata:[],hascheckdata: false,count2:0 } })
                if(value.msg === '请登陆！') {
                    localStorage.removeItem('daka_token');
                    alert('账号已在别处登录,请重新登录')
                    this.props.history.push('/')
                }
            } else {
                 if(value.data!=''){
                     let newlist=[];
                     newlist = value.data.data
                     if(oldData && oldData.length > 0) {
                         newlist = oldData.concat(value.data.data)
                     }
                     dispatch({ type: JIABANBUKA_LIST, payload:{checklistdata: newlist,hascheckdata: true,count2:value.data.count } })
                 }
                 else {
                     //alert(value.msg)
                     dispatch({ type: JIABANBUKA_LIST, payload:{checklistdata:[],hascheckdata: false,count2:0 } })
                 }
            }
        })
    }
}

export const deleteJiaBanBuka = (body,history) => {
    return async (dispatch, getState) => {
        postRequest(`/jiabanbk/del`, body).then((value) => {
            //console.log(value);
            if(value.Status === 0) {
                Toast.info(value.msg, 1);
                if(value.msg === '请登陆！') {
                    localStorage.removeItem('daka_token')
                    alert('账号已在别处登录,请重新登录')
                    this.props.history.push('/')
                }
            } else {
                Toast.success('删除成功！', 1);
                dispatch(getJiaBanBuka());
            }
        })
    }
}

